import React from "react";
import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import _Button from "../../../generic/_Button";
import { useMutation, useQuery } from "@tanstack/react-query";
import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";
import { useAuth } from "../../../../Context/AuthContext";
import { useFormik } from "formik";
import * as Yup from "yup";
import _Input from "../../../generic/_Input";
import _Select from "../../../generic/_Select";
import { errorLabels } from "../../../../utils/helpers";
import { ErrorMessage, SuccessMessage } from "../../../../utils/toastify";
const _ModalCreateRCSAgent = (props) => {
  const {
    visible = false,
    onClose,
    title = "",
    data = {
      idCustomer: "",
      uidCustomer: "",
    },
    refetchAgentsRcs,
  } = props;

  const auth = useAuth();
  const { token } = auth.getSessionData();

  const {
    values,
    handleChange,
    handleBlur,
    touched,
    errors,
    validateForm,
    submitForm,
    resetForm,
  } = useFormik({
    initialValues: {
      idpartner: "",
      rcsprovider: "",
      singlekey: "",
      basickey: "",
      carrier: null,
      token: null,
      apikey: null,
      name: "",
      agentid: "",
    },
    validationSchema: Yup.object({
      idpartner: Yup.string().required("El partner es requerido"),
      rcsprovider: Yup.string().required("El proveedor RCS es requerido"),
      singlekey: Yup.string().required("El single key es requerido"),
      basickey: Yup.string().required("El basic key es requerido"),
      name: Yup.string().optional("El nombre es requerido"),
      agentid: Yup.string().optional("El id del agente es requerido"),
    }),
    onSubmit: async (values) => {
       createRCSAgent(values);
    },
  });

  const { data: optionsData } = useQuery({
    queryKey: ["partnersList", data?.idCustomer, data?.uidCustomer],
    queryFn: async () => {
      const [responsePartners, responseCarriers, responseProviderRcs] =
        await Promise.all([
          httpClient(
            "get",
            `${ApiEndpoint}partners/${data?.idCustomer}`,
            {},
            token,
          ),
          httpClient("get", `${ApiEndpoint}carriers`, {}, token),
          httpClient("get", `${ApiEndpoint}rcsproviders`, {}, token),
        ]);

      return {
        partners: responsePartners.data || [],
        carriers: responseCarriers.data || [],
        rcsProviders: responseProviderRcs.data || [],
      };
    },
    enabled: visible,
    initialData: {
      partners: [],
      carriers: [],
      rcsProviders: [],
    },
    refetchOnWindowFocus: false,
  });

  const partners = optionsData?.partners || [];
  const carriers = optionsData?.carriers || [];
  const rcsProviders = optionsData?.rcsProviders || [];

  /*eslint-disable */
  const { mutate: createRCSAgent } = useMutation({
    mutationKey: ["createRCSAgent"],
    mutationFn: async (values) => {
     const response = await httpClient(
       "post",
       `${ApiEndpoint}administration/asignrcsprovider`,
       {
        ...values,
        rcsprovider: parseFloat(values.rcsprovider),
       },
       token,
     );
     console.log(response.data);
     return response.data;
    },
    onSuccess: (data) => {
      if(data?.error) {
        ErrorMessage("Error al agregar agente");
        return;
      }
      _onClose();
      refetchAgentsRcs();
      SuccessMessage("Agente Agregado");
    },
    onError: (error) => {
      console.log(error);
      ErrorMessage("Error al agregar agente");
    },
  });

  const _onClose = () => {
    if (onClose) {
      onClose();
      resetForm();
    }
  };

  const onValidate = async () => {
    try {
      const isValid = await validateForm();

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errorLabels(isValid)}`);
      }
      await submitForm();
    } catch (error) {
      ErrorMessage(error.message);
    }
  };

  return (
    <Modal show={visible} onHide={_onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="text-xl font-semibold text-gray-600">{title}</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="grid grid-cols-2 gap-2">
          <_Input
            title="Nombre"
            id="name"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            isError={touched.name && errors.name}
            errors={touched.name && errors.name ? errors.name : ""}
            autoComplete={"off"}
            required
          />
          <_Input
            title="Agente"
            id="agentid"
            value={values.agentid}
            onChange={handleChange}
            onBlur={handleBlur}
            isError={touched.agentid && errors.agentid}
            errors={
              touched.agentid && errors.agentid ? errors.agentid : ""
            }
            autoComplete={"off"}
            required
          />
        </div>
        <div className="grid grid-cols-2 gap-2">
          <_Select
            title="Partner"
            id="idpartner"
            value={values.idpartner}
            onChange={handleChange}
            onBlur={handleBlur}
            isError={touched.idpartner && errors.idpartner}
            errors={
              touched.idpartner && errors.idpartner ? errors.idpartner : ""
            }
            options={[
              {
                value: "",
                label: "Seleccione un partner",
              },
              ...partners.map((partner) => ({
                value: partner.uidpartner,
                label: partner.name,
              })),
            ]}
            required
          />

          <_Select
            title="Proveedor RCS"
            id="rcsprovider"
            value={values.rcsprovider}
            onChange={handleChange}
            onBlur={handleBlur}
            isError={touched.rcsprovider && errors.rcsprovider}
            errors={
              touched.rcsprovider && errors.rcsprovider
                ? errors.rcsprovider
                : ""
            }
            options={[
              {
                value: "",
                label: "Seleccione un proveedor RCS",
              },
              ...rcsProviders.map((item) => ({
                value: item.idrcsprovider,
                label: item.provider,
              })),
            ]}
            required
          />
        </div>

        <div className="grid grid-cols-2 gap-2">
          <_Input
            title="Single key"
            id="singlekey"
            value={values.singlekey}
            onChange={handleChange}
            onBlur={handleBlur}
            isError={touched.singlekey && errors.singlekey}
            errors={
              touched.singlekey && errors.singlekey ? errors.singlekey : ""
            }
            type="password"
            autoComplete={"off"}
            required
          />
          <_Input
            title="Basic key"
            id="basickey"
            value={values.basickey}
            onChange={handleChange}
            onBlur={handleBlur}
            isError={touched.basickey && errors.basickey}
            errors={touched.basickey && errors.basickey ? errors.basickey : ""}
            type="password"
            autoComplete={"off"}
            required
          />
        </div>
        <div className="Divider"></div>
        <div className="grid grid-cols-3 gap-2">
          <_Select
            title="Carrier"
            id="carrier"
            value={values.carrier}
            onChange={handleChange}
            onBlur={handleBlur}
            isError={touched.carrier && errors.carrier}
            errors={touched.carrier && errors.carrier ? errors.carrier : ""}
            options={[
              {
                value: "",
                label: "Seleccione un carrier",
              },
              ...carriers.map((item) => {
                return {
                  value: item.idcarrier,
                  label: item.carrier,
                };
              }),
            ]}
          />
          <_Input
            title="Token"
            id="token"
            value={values.token}
            onChange={handleChange}
            onBlur={handleBlur}
            isError={touched.token && errors.token}
            type="password"
            autoComplete={"off"}
            errors={touched.token && errors.token ? errors.token : ""}
          />
          <_Input
            title="API Key"
            id="apikey"
            value={values.apikey}
            onChange={handleChange}
            onBlur={handleBlur}
            isError={touched.apikey && errors.apikey}
            type="password"
            autoComplete={"off"}
            errors={touched.apikey && errors.apikey ? errors.apikey : ""}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <_Button title="Cerrar" style="outline" onClick={_onClose} />
        <_Button title="Guardar" style="primary" onClick={onValidate} />
      </Modal.Footer>
    </Modal>
  );
};

_ModalCreateRCSAgent.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  data: PropTypes.object,
  refetchAgentsRcs: PropTypes.func,
};

export default _ModalCreateRCSAgent;
